/**
 * Whether the PestControl module should be shown for a crop config.
 *
 * `cropConfig.pestControlPlans` arrives in two different shapes:
 * - Edit / AIO page: the user selection — an array (or id-keyed map) of control plans.
 * - Only-read / PDF: the raw SWR object `{ data: { results }, isLoading, isValidating }`,
 *   because the `PestControl` component renders `pestControlPlans.data.results`.
 *
 * A naive `Object.values(...).filter(Boolean).length > 0` treats the SWR wrapper's own
 * keys as entries, so it returns true even when there are zero results (or while loading).
 * Discriminate on the SWR wrapper explicitly.
 */
export const hasPestControlPlans = (pestControlPlans: unknown): boolean => {
    if (!pestControlPlans || typeof pestControlPlans !== 'object') return false;
    // SWR-shaped (only-read / PDF): count actual results, ignore loading state.
    if ('isValidating' in pestControlPlans) {
        return ((pestControlPlans as { data?: { results?: unknown[] } }).data?.results?.length ?? 0) > 0;
    }
    // Selection-shaped (edit / AIO page): array or id-keyed map of control plans.
    return Object.values(pestControlPlans).filter(Boolean).length > 0;
};
